import { Box, Heading } from '@wix/design-system';
import { DomainWithEllipsis } from '@wix/domains-search-suite';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './HeroBusinessEmailExample.css';
export const HeroBusinessEmailExample = _ref => {
  let {
    domain,
    size = 'medium'
  } = _ref;
  const {
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "7px",
    align: "left",
    dataHook: "hero-business-email-example"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    className: size === 'small' ? s.headingSmall : s.heading
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.business_email_results.hero.email_example",
    values: {
      domainName: domain
    },
    components: [/*#__PURE__*/React.createElement(DomainWithEllipsis, {
      maxWidth: size === 'small' ? '160px' : '300px',
      textComponent: Heading,
      textComponentProps: {
        size: 'medium',
        as: 'span'
      }
    })]
  })));
};
//# sourceMappingURL=HeroBusinessEmailExample.js.map